import { render } from "./resultPage.vue?vue&type=template&id=405964de&scoped=true&ts=true"
import script from "./resultPage.vue?vue&type=script&lang=ts"
export * from "./resultPage.vue?vue&type=script&lang=ts"

import "./resultPage.vue?vue&type=style&index=0&id=405964de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405964de"]])

export default __exports__